var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.186 6.45348H8.54652V0.813954C8.54652 0.557051 8.19767 0 7.5 0C6.80233 0 6.45348 0.557082 6.45348 0.813954V6.45351H0.813954C0.557082 6.45348 0 6.80233 0 7.49997C0 8.19761 0.557082 8.54649 0.813954 8.54649H6.45351V14.186C6.45351 14.4429 6.80233 15 7.50003 15C8.19773 15 8.54655 14.4429 8.54655 14.186V8.54649H14.1861C14.443 8.54649 15.0001 8.19767 15.0001 7.49997C15.0001 6.80227 14.4429 6.45348 14.186 6.45348Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c3eaad182945e88085a038fb26b1d61e.svg";
export { ForwardRef as ReactComponent };